import React from 'react';
import styles from './Geometry.module.scss';

const Geometry = props => {
  return <div className={styles.geometry} {...props} />;
};

export default Geometry;
